// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../decco/lib/es6_global/src/Decco.bs.js";
import * as Js_dict from "../../../../rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../rescript/lib/es6/js_json.js";
import * as Caml_obj from "../../../../rescript/lib/es6/caml_obj.js";
import * as Js_array from "../../../../rescript/lib/es6/js_array.js";
import * as Belt_Array from "../../../../rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../rescript/lib/es6/belt_Option.js";
import * as Facets$ApiTypes from "./Facets.bs.js";

var facet_encode = Decco.stringToJson;

var facet_decode = Decco.stringFromJson;

function color_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "label",
                Decco.stringToJson(v.label)
              ],
              [
                "facet",
                Decco.stringToJson(v.facet)
              ],
              [
                "colorValue",
                Decco.stringToJson(v.colorValue)
              ]
            ]);
}

function color_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      var facet = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "facet"), null));
      if (facet.TAG === /* Ok */0) {
        var colorValue = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "colorValue"), null));
        if (colorValue.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    label: label._0,
                    facet: facet._0,
                    colorValue: colorValue._0
                  }
                };
        }
        var e = colorValue._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".colorValue" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = facet._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".facet" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function image_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "label",
                Decco.stringToJson(v.label)
              ],
              [
                "facet",
                Decco.stringToJson(v.facet)
              ],
              [
                "imageUrl",
                Decco.stringToJson(v.imageUrl)
              ]
            ]);
}

function image_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      var facet = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "facet"), null));
      if (facet.TAG === /* Ok */0) {
        var imageUrl = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "imageUrl"), null));
        if (imageUrl.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    label: label._0,
                    facet: facet._0,
                    imageUrl: imageUrl._0
                  }
                };
        }
        var e = imageUrl._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".imageUrl" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = facet._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".facet" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function checkbox_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "label",
                Decco.stringToJson(v.label)
              ],
              [
                "facet",
                Decco.stringToJson(v.facet)
              ]
            ]);
}

function checkbox_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      var facet = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "facet"), null));
      if (facet.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: id._0,
                  label: label._0,
                  facet: facet._0
                }
              };
      }
      var e = facet._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".facet" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function intermediate_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "label",
                Decco.stringToJson(v.label)
              ],
              [
                "facet",
                Decco.stringToJson(v.facet)
              ],
              [
                "value",
                Decco.optionToJson(Decco.stringToJson, v.value)
              ]
            ]);
}

function intermediate_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      var facet = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "facet"), null));
      if (facet.TAG === /* Ok */0) {
        var value = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
        if (value.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    label: label._0,
                    facet: facet._0,
                    value: value._0
                  }
                };
        }
        var e = value._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".value" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = facet._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".facet" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

var Item = {
  color_encode: color_encode,
  color_decode: color_decode,
  image_encode: image_encode,
  image_decode: image_decode,
  checkbox_encode: checkbox_encode,
  checkbox_decode: checkbox_decode,
  intermediate_encode: intermediate_encode,
  intermediate_decode: intermediate_decode
};

function data_encode(encoder_a, v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.stringToJson(v.id)
              ],
              [
                "label",
                Decco.stringToJson(v.label)
              ],
              [
                "options",
                Decco.arrayToJson(encoder_a, v.options)
              ],
              [
                "visible",
                Decco.boolToJson(v.visible)
              ]
            ]);
}

function data_decode(decoder_a, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      var options = Decco.arrayFromJson(decoder_a, Belt_Option.getWithDefault(Js_dict.get(dict$1, "options"), null));
      if (options.TAG === /* Ok */0) {
        var visible = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "visible"), Decco.boolFromJson), {
              TAG: /* Ok */0,
              _0: true
            });
        if (visible.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    id: id._0,
                    label: label._0,
                    options: options._0,
                    visible: visible._0
                  }
                };
        }
        var e = visible._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".visible" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = options._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".options" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_encode(v) {
  switch (v.TAG | 0) {
    case /* ColorCheckbox */0 :
        return [
                "ColorCheckbox",
                data_encode(color_encode, v._0)
              ];
    case /* ImageCheckbox */1 :
        return [
                "ImageCheckbox",
                data_encode(image_encode, v._0)
              ];
    case /* Checkbox */2 :
        return [
                "Checkbox",
                data_encode(checkbox_encode, v._0)
              ];
    
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Checkbox" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = data_decode(checkbox_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Checkbox */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ColorCheckbox" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = data_decode(color_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ColorCheckbox */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ImageCheckbox" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = data_decode(image_decode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ImageCheckbox */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var Section = {
  data_encode: data_encode,
  data_decode: data_decode,
  t_encode: t_encode,
  t_decode: t_decode
};

function t_encode$1(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.arrayFromJson(t_decode, v);
}

function getSectionOptions(section) {
  switch (section.TAG | 0) {
    case /* ColorCheckbox */0 :
        return Belt_Array.map(section._0.options, (function (opt) {
                      return {
                              id: opt.id,
                              label: opt.label,
                              facet: opt.facet,
                              value: opt.colorValue
                            };
                    }));
    case /* ImageCheckbox */1 :
        return Belt_Array.map(section._0.options, (function (opt) {
                      return {
                              id: opt.id,
                              label: opt.label,
                              facet: opt.facet,
                              value: opt.imageUrl
                            };
                    }));
    case /* Checkbox */2 :
        return Belt_Array.map(section._0.options, (function (opt) {
                      return {
                              id: opt.id,
                              label: opt.label,
                              facet: opt.facet,
                              value: undefined
                            };
                    }));
    
  }
}

function getFacets(section) {
  var array = Belt_Array.map(getSectionOptions(section), (function (option) {
          return option.facet;
        }));
  if (Caml_obj.equal(array, [])) {
    return ;
  } else {
    return array;
  }
}

function getFacets2D(sections) {
  return Belt_Array.keepMap(Belt_Array.map(sections, getFacets), (function (facetGroup) {
                return facetGroup;
              }));
}

function getFacetsByKVPair(config, kvPair) {
  return Facets$ApiTypes.make(undefined, undefined, Belt_Array.keep(Belt_Array.mapWithIndex(Belt_Array.concatMany(Belt_Array.map(config, (function (c) {
                                switch (c.TAG | 0) {
                                  case /* ColorCheckbox */0 :
                                      return Belt_Array.map(c._0.options, (function (param) {
                                                    return param.facet;
                                                  }));
                                  case /* ImageCheckbox */1 :
                                      return Belt_Array.map(c._0.options, (function (param) {
                                                    return param.facet;
                                                  }));
                                  case /* Checkbox */2 :
                                      return Belt_Array.map(c._0.options, (function (param) {
                                                    return param.facet;
                                                  }));
                                  
                                }
                              }))), (function (i, f) {
                        return {
                                facet: f,
                                index: i
                              };
                      })), (function (param) {
                    var facet = param.facet;
                    return Belt_Array.some(kvPair, (function (kv) {
                                  return kv === facet;
                                }));
                  })));
}

export {
  facet_encode ,
  facet_decode ,
  Item ,
  Section ,
  t_encode$1 as t_encode,
  t_decode$1 as t_decode,
  getSectionOptions ,
  getFacets ,
  getFacets2D ,
  getFacetsByKVPair ,
}
/* Facets-ApiTypes Not a pure module */
